module.exports = __webpack_public_path__ + "img/il.5a12c248.svg";